var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4251 0.499878C22.6626 0.499878 25.5001 3.47488 25.5001 7.89988V18.1136C25.5001 22.5249 22.6626 25.4999 18.4251 25.4999H7.58762C3.35012 25.4999 0.500122 22.5249 0.500122 18.1136V7.89988C0.500122 3.47488 3.35012 0.499878 7.58762 0.499878H18.4251ZM18.2251 9.24988C17.8001 8.82488 17.1001 8.82488 16.6751 9.24988L11.5126 14.4124L9.32512 12.2249C8.90012 11.7999 8.20012 11.7999 7.77512 12.2249C7.35012 12.6499 7.35012 13.3374 7.77512 13.7749L10.7501 16.7374C10.9626 16.9499 11.2376 17.0499 11.5126 17.0499C11.8001 17.0499 12.0751 16.9499 12.2876 16.7374L18.2251 10.7999C18.6501 10.3749 18.6501 9.68738 18.2251 9.24988Z",
    fill: "#FBFBFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/tick-square.eebf929f.svg";
export { ForwardRef as ReactComponent };